import React from 'react';
import Span from '../../Texts/Span/Span';
import P from '../../Texts/P/P';
import { numberFormatter } from '../../../utils/Utils';

const textColors = {
  negative: { variant: 'danger', modifier: 'regular' },
  positive: { variant: 'neutral', modifier: 'strong' },
};

export const AmountFormatter = ({ cell, formatExtraData }) => {
  const AmountRender = ({ amount, sign }) => (
    <Span
      variant={textColors[sign].variant}
      modifier={textColors[sign].modifier}
      type='4'
    >
      {amount}
    </Span>
  );
  if (cell || cell === 0) {
    const amount = numberFormatter.format(cell?.amount || cell);
    const sign = amount.includes('-$') ? 'negative' : 'positive';
    switch (formatExtraData.format) {
      case 'helperText':
        return (
          <>
            <AmountRender amount={amount} sign={sign} />
            <P variant='neutral' type='5' align='right'>
              {cell.helperText}
            </P>
          </>
        );
      default:
        return <AmountRender amount={amount} sign={sign} />;
    }
  } else return null;
};
